export function getBlogSchema({ posts, blogUrl, blogName, blogDescription, logoUrl, publisherUrl }) {
  return {
    "@context": "https://schema.org",
    "@type": "Blog",
    name: blogName,
    url: blogUrl,
    description: blogDescription,
    publisher: {
      "@type": "Organization",
      name: "Mangomint",
      url: publisherUrl,
      logo: {
        "@type": "ImageObject",
        url: logoUrl,
      },
    },
    blogPost: posts.map((post) => ({
      "@type": "BlogPosting",
      headline: post.title,
      url: post.path,
      datePublished: post.publishedAt,
      author: {
        "@type": "Person",
        name: post.author?.name,
      },
      image: post.featureImage?.full?.images?.fallback?.src,
    })),
  };
}

export function getBlogPostingSchema({ post, logoUrl, publisherUrl }) {
  let imageUrl;
  if (post.featureImage?.social?.images?.fallback?.src) {
    imageUrl = post.featureImage.social.images.fallback.src;
  }
  return {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    headline: post.title,
    description: post.metaDescription?.metaDescription || post.subhead?.subhead,
    datePublished: post.publishedAt,
    author: {
      "@type": "Person",
      name: post.author?.name,
    },
    image: imageUrl,
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": post.articlePath,
    },
    publisher: {
      "@type": "Organization",
      name: "Mangomint",
      url: publisherUrl,
      logo: {
        "@type": "ImageObject",
        url: logoUrl,
      },
    },
  };
}
